import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';

import { getItem, getItemErrors, setItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, editPayrollRulesGroup } from 'src/reducers/clients/payrollRulesGroups';

import PayrollRulesGroupForm from './containers/PayrollRulesGroupForm';
import { calculateDateForForm } from './utils';

let EditPayrollRulesGroupForm = reduxForm({
  form: PAYROLL_RULES_GROUP_FORM
})(PayrollRulesGroupForm);

const mapStateToProps = state => ({
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    ...calculateDateForForm(getItem(REDUCER_NAME, state)),
    timingOfTaxDeduction: getItem(REDUCER_NAME, state)?.calcSscSeparately || '0'
  },
  isNewForm: false,
  errors: getItemErrors(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(editPayrollRulesGroup(data));
  }
});

EditPayrollRulesGroupForm = connect(mapStateToProps, mapDispatchToProps)(EditPayrollRulesGroupForm);

const EditPayrollRulesGroup = ({ dispatch, clientPayrollRulesGroup }) => {
  const { t } = useTranslation();
  dispatch(setItem(REDUCER_NAME, clientPayrollRulesGroup));
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.PayrollRulesGroups.EditPayrollRulesGroup.Edit_salary_rules')}</h1>
      </div>
      <div className="l-wrap-xs">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item
              label={t('features.PayrollRulesGroups.EditPayrollRulesGroup.Salary_rules_group_list')}
              path={CLIENT_PAYROLL_RULES_GROUP_LIST}
            />
            <BreadCrumb.Item label={t('features.PayrollRulesGroups.EditPayrollRulesGroup.Edit_salary_rules')} />
          </BreadCrumb>
        </div>
        <EditPayrollRulesGroupForm />
      </div>
    </div>
  );
};

export default connect()(EditPayrollRulesGroup);
